import { client } from 'cccisd-apollo';
import parentDeploymentQuery from './parentDeployment.graphql';
import { GOALS_DEPLOYMENT_HANDLE } from '../pages/TfhCoachDashboard/Goals';
import { DAILY_TRACKING_DEPLOYMENT_HANDLE } from '../pages/DailyTracking';

export function renderFamilyMemberName(member, allFamilyMembers) {
    if (!member?.user) {
        return;
    }

    if (
        member.user.firstName &&
        !allFamilyMembers.find(
            someoneElse =>
                someoneElse.user.firstName === member.user.firstName && someoneElse.pawn.pawnId !== member.pawn.pawnId
        )
    ) {
        return member.user.firstName;
    }

    if (
        member.user.firstName &&
        member.user.lastName &&
        !allFamilyMembers.find(
            someoneElse =>
                someoneElse.user.lastName === member.user.lastName && someoneElse.pawn.pawnId !== member.pawn.pawnId
        )
    ) {
        return `${member.user.firstName} ${member.user.lastName}`;
    }

    if (member.user.firstName) {
        return `${member.user.firstName} (${member.user.username})`;
    }

    return member.user.username;
}

export async function getGoalsParentDeploymentId() {
    const resp = await client.query({
        query: parentDeploymentQuery,
        variables: {
            handle: GOALS_DEPLOYMENT_HANDLE,
        },
        fetchPolicy: 'cache-first',
    });

    return resp.data.flows.deployment.deploymentId;
}

export async function getDailyTrackingParentDeploymentId() {
    const resp = await client.query({
        query: parentDeploymentQuery,
        variables: {
            handle: DAILY_TRACKING_DEPLOYMENT_HANDLE,
        },
        fetchPolicy: 'cache-first',
    });

    return resp.data.flows.deployment.deploymentId;
}
